import store from "@/store/VuexPlugin";
import { restoreFromLocalStorage } from "@/lib/restoreFromLocalStorage";
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "ui",
  store
})
export class UiStore extends VuexModule {
  /**
   * Stores a global loading state.
   */
  loading = true;

  /**
   * Stores the <see cref="TheLayoutBase"/> drawer state.
   */
  drawer: boolean | null = false;

  /**
   * Resource that is currently active on the booking view.
   */
  bookingSelectedResourceId: string | null = restoreFromLocalStorage("bookingSelectedResourceId", "ui", null);

  /**
   * Resources whose bookings are displayed on the booking calendar.
   * Null means nothing was explicitly chosen yet, so all resources are shown
   */
  bookingVisibleResourceIds: string[] | null = restoreFromLocalStorage("bookingVisibleResourceIds", "ui", null);

  /**
   * Whether the resource side panel on the booking view is expanded.
   */
  bookingShowResourcePanel: boolean = restoreFromLocalStorage("bookingShowResourcePanel", "ui", true);

  /**
   * Sets the drawer to open or closed
   * @param val Sets the drawer to open or closed
   */
  @Action
  setDrawer(val: boolean | null) {
    this.context.commit("updateDrawer", val);
  }

  /**
   * Toggles the menu drawer
   * @param val drawer open or closed
   */
  @Mutation
  updateDrawer(val: boolean | null) {
    this.drawer = val;
  }

  /**
   * Sets a global loading state for the ui.
   * @param loading boolean if loading is true
   * @returns loading status
   */
  @MutationAction
  async setLoading(loading: boolean) {
    return {
      loading
    };
  }

  @Mutation
  updateBookingSelectedResourceId(resourceId: string | null) {
    this.bookingSelectedResourceId = resourceId;
  }

  @Action
  setBookingSelectedResourceId(resourceId: string | null) {
    this.context.commit("updateBookingSelectedResourceId", resourceId);
  }

  @Mutation
  updateBookingVisibleResourceIds(resourceIds: string[] | null) {
    this.bookingVisibleResourceIds = resourceIds;
  }

  @Action
  setBookingVisibleResourceIds(resourceIds: string[] | null) {
    this.context.commit("updateBookingVisibleResourceIds", resourceIds);
  }

  @Mutation
  updateBookingShowResourcePanel(show: boolean) {
    this.bookingShowResourcePanel = show;
  }

  @Action
  setBookingShowResourcePanel(show: boolean) {
    this.context.commit("updateBookingShowResourcePanel", show);
  }
}

export const UiModule = getModule(UiStore);
